var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { collectionsProgressDetailsSelector, INVALIDATE, removeCardsFromCollections, setCollectionStatus, updateCollectionAfterSave, updateSlotsAfterSave, } from './collectionProgress';
import { isProgressItemFetched, } from './types';
import { hideCollection as hideCollectionRequest, submitCollection as submitCollectionRequest, updateCollection as updateCollectionRequest, } from '../../api/collections';
import { addPurchases } from '../../actions/PurchaseActions';
import { authSelector } from '../../selectors';
import { hideCollection as hideCollectionInternal } from './collectionsList';
import { updateOwnedCollection } from './ownedCollections';
import { cardsItemsSelector, fetchCard, setCollectionOfCard, updateCollectionRecordsCount, } from '../cards';
import { isEmptyObject } from '../../utils/records';
import { fetchCountryIfNeeded } from '../../actions/CountryActions';
export var submitCollection = function (collectionId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var currentProgress, _a, apiUrl, token, result;
    var _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                currentProgress = collectionsProgressDetailsSelector(getState(), collectionId);
                if (!isProgressItemFetched(currentProgress) ||
                    !((_c = (_b = currentProgress.progress) === null || _b === void 0 ? void 0 : _b.slots) === null || _c === void 0 ? void 0 : _c.length)) {
                    return [2 /*return*/, null];
                }
                _a = authSelector(getState()), apiUrl = _a.apiUrl, token = _a.token;
                return [4 /*yield*/, submitCollectionRequest(apiUrl, token, collectionId, currentProgress.progress.slots)];
            case 1:
                result = _e.sent();
                dispatch(updateSlotsAfterSave(collectionId, result.progress.slots));
                dispatch(setCollectionStatus(collectionId, result.progress.status));
                dispatch(updateOwnedCollection(currentProgress.collection, result.progress.status, result.progress.slots, result.progress._id));
                if ((_d = result.purchases) === null || _d === void 0 ? void 0 : _d.length) {
                    dispatch(addPurchases(result.purchases));
                }
                return [2 /*return*/, result];
        }
    });
}); }; };
export var hideCollection = function (collectionId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, apiUrl, token;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = authSelector(getState()), apiUrl = _a.apiUrl, token = _a.token;
                return [4 /*yield*/, hideCollectionRequest(apiUrl, token, collectionId)];
            case 1:
                _b.sent();
                dispatch(hideCollectionInternal(collectionId));
                return [2 /*return*/];
        }
    });
}); }; };
var updateCollection = function (collectionId, getNewSlots) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var currentProgress, _a, apiUrl, token, newSlots, country, result_1, cards_1, addedCardsCount_1, e_1;
    var _b, _c, _d, _e, _f, _g, _h;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                currentProgress = collectionsProgressDetailsSelector(getState(), collectionId);
                if (!isProgressItemFetched(currentProgress)) {
                    return [2 /*return*/];
                }
                _a = authSelector(getState()), apiUrl = _a.apiUrl, token = _a.token;
                newSlots = getNewSlots(currentProgress);
                if (!currentProgress || !apiUrl || !token || !newSlots) {
                    return [2 /*return*/];
                }
                dispatch(updateSlotsAfterSave(collectionId, newSlots));
                _j.label = 1;
            case 1:
                _j.trys.push([1, 4, , 5]);
                return [4 /*yield*/, dispatch(fetchCountryIfNeeded())];
            case 2:
                country = _j.sent();
                return [4 /*yield*/, updateCollectionRequest(apiUrl, token, collectionId, newSlots, country)];
            case 3:
                result_1 = _j.sent();
                dispatch(updateSlotsAfterSave(collectionId, result_1.progress.slots));
                dispatch(updateOwnedCollection((_b = result_1.collection) !== null && _b !== void 0 ? _b : currentProgress.collection, result_1.progress.status, result_1.progress.slots, result_1.progress._id));
                if (result_1.collection) {
                    dispatch(updateCollectionAfterSave(result_1.collection));
                }
                if ((_c = result_1.invalidCards) === null || _c === void 0 ? void 0 : _c.length) {
                    dispatch(removeCardsFromCollections(result_1.invalidCards));
                }
                cards_1 = cardsItemsSelector(getState());
                // Set card.cardCollection to undefined for cards that were removed in the update...
                (_e = (_d = currentProgress.progress) === null || _d === void 0 ? void 0 : _d.slots) === null || _e === void 0 ? void 0 : _e.forEach(function (slot) {
                    if (!isEmptyObject(slot) &&
                        slot.card &&
                        !result_1.progress.slots.some(function (newSlot) { return !isEmptyObject(newSlot) && newSlot.card === slot.card; })) {
                        dispatch(setCollectionOfCard(slot.card, undefined));
                        if (slot.card in cards_1) {
                            dispatch(updateCollectionRecordsCount(-1));
                        }
                        else {
                            dispatch(fetchCard(slot.card)).then(function () {
                                return dispatch(updateCollectionRecordsCount(-1));
                            });
                        }
                    }
                });
                addedCardsCount_1 = 0;
                // ...and set it to an id of this collection for cards that were added.
                result_1.progress.slots.forEach(function (newSlot) {
                    var _a, _b;
                    if (!isEmptyObject(newSlot) &&
                        newSlot.card &&
                        !((_b = (_a = currentProgress.progress) === null || _a === void 0 ? void 0 : _a.slots) === null || _b === void 0 ? void 0 : _b.some(function (slot) { return !isEmptyObject(slot) && slot.card === newSlot.card; }))) {
                        dispatch(setCollectionOfCard(newSlot.card, collectionId));
                        addedCardsCount_1 += 1;
                    }
                });
                if (addedCardsCount_1) {
                    dispatch(updateCollectionRecordsCount(addedCardsCount_1));
                }
                return [3 /*break*/, 5];
            case 4:
                e_1 = _j.sent();
                if ((_g = (_f = currentProgress === null || currentProgress === void 0 ? void 0 : currentProgress.progress) === null || _f === void 0 ? void 0 : _f.slots) === null || _g === void 0 ? void 0 : _g.length) {
                    dispatch(updateSlotsAfterSave(collectionId, (_h = currentProgress === null || currentProgress === void 0 ? void 0 : currentProgress.progress) === null || _h === void 0 ? void 0 : _h.slots));
                }
                dispatch({ type: INVALIDATE });
                throw e_1;
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var insertCollectionCard = function (collectionId, slotIndex, cardId) {
    return updateCollection(collectionId, function (currentProgress) {
        var _a, _b, _c;
        var selectedCardTemplate = (_c = (_b = (_a = currentProgress === null || currentProgress === void 0 ? void 0 : currentProgress.cards) === null || _a === void 0 ? void 0 : _a.find(function (card) { return card._id === cardId; })) === null || _b === void 0 ? void 0 : _b.cardTemplate) === null || _c === void 0 ? void 0 : _c._id;
        if (!selectedCardTemplate) {
            return undefined;
        }
        return currentProgress.collection.slots.map(function (collectionSlot, i) {
            var _a, _b;
            if (i === slotIndex) {
                return {
                    card: cardId,
                    cardTemplate: selectedCardTemplate,
                };
            }
            var currentSlot = (_b = (_a = currentProgress.progress) === null || _a === void 0 ? void 0 : _a.slots) === null || _b === void 0 ? void 0 : _b[i];
            if (currentSlot !== undefined) {
                return currentSlot;
            }
            if (isEmptyObject(collectionSlot)) {
                return collectionSlot;
            }
            return { card: null };
        });
    });
};
export var removeCollectionCard = function (collectionId, slotIndex) {
    return updateCollection(collectionId, function (currentProgress) {
        return currentProgress.collection.slots.map(function (collectionSlot, i) {
            var _a, _b;
            if (isEmptyObject(collectionSlot)) {
                return {};
            }
            if (i === slotIndex) {
                return { card: null };
            }
            var currentSlot = (_b = (_a = currentProgress.progress) === null || _a === void 0 ? void 0 : _a.slots) === null || _b === void 0 ? void 0 : _b[i];
            return currentSlot !== null && currentSlot !== void 0 ? currentSlot : { card: null };
        });
    });
};
